// import React from 'react';
// import '../ContactUs/ContactUs.css';
// import Footer from '../../compos/Footer/Footer';
// import Header from '../../compos/Header/Header';
// import { LoginProps } from '../Login/Login';
// import BReporter from '../../Media/Icons/BReporter.png';
// import { useUser } from '../../UserContext';
// import { Navigate, useNavigate } from 'react-router-dom';
// const ContactUs = () => {
// 	const {user,set_user} = useUser();
// 	const navigate = useNavigate();
// 	window.addEventListener('load', function () {
// 		const form = document.getElementById('my-form') as HTMLFormElement;
// 		form.addEventListener('submit', function (e) {
// 			e.preventDefault();
// 			const data = new FormData(form);
// 			const action = form.action;
// 			fetch(action, {
// 				method: 'POST',
// 				body: data,
// 			}).then(() => {
// 				alert('Success!');
// 			});
// 		});
// 	});

// 	return (
// 		<div style={{ overflowX: 'hidden' }}>
// 			<Header />
// 			<div style={{ overflowX: 'hidden', marginTop: '90px' }}>
// 				{/* <div className='row msp-lab'>
// 					<div className='h-100'>
// 						<div className='row d-flex justify-center align-items-center h-100' style={{ marginBottom: '0px' }}>
// 							<div className='col-5 col-sm-3 d-flex justify-center align-items-center' style={{ padding: '10px' }}>
// 								<img
// 									className='responsive-img p-3 '
// 									style={{ maxHeight: '250px', maxWidth: '250px' }}
// 									src='https://web.iitd.ac.in/~lalank/msp/images/iitd_logo.png'
// 								/>
// 							</div>
// 							<div
// 								className='col-7 col-sm-7 d-flex justify-center align-items-center flex-col'
// 								style={{ paddingTop: '10px', paddingRight: '40px' }}
// 							>
// 								<h2 className='w-100'>
// 									<b>Multichannel Signal Processing Laboratory</b>
// 								</h2>
// 							</div>
// 						</div>
// 					</div>
// 				</div> */}
// 				<div className='user-contact row'>
// 					<div className='contact-us'>
// 						<form
// 							id='my-form'
// 							className='forms_form'
// 							method='POST'
// 							action='https://script.google.com/macros/s/AKfycbwVOMlBZXq-XhzgC1SM180lF-MgwPEM8eKuiFawEdd1AentrQE4-eNWjuE6y4kD4KZ7Vw/exec'
// 							onSubmit={(e) => {
// 								navigate('/contact');
// 							}}
// 						>
// 							<h2 className='forms_title'>Drop us a line</h2>
// 							<fieldset className='forms_fieldset'>
// 								<div className='forms_field'>
// 									<i className='fa fa-solid fa-user-circle mx-2'></i>
// 									<input type='text' name='Name' placeholder='Name' className='forms_field-input' required />
// 								</div>
// 								<div className='forms_field'>
// 									<i className='fa fa-solid fa-envelope-open mx-2'></i>
// 									<input type='email' name='Email' placeholder='Email' className='forms_field-input' required />
// 								</div>
// 								<div className='forms_field'>
// 									<i className='fa fa-solid fa-phone mx-2'></i>
// 									<input placeholder='Phone' name='Phone' className='forms_field-input' required />
// 								</div>
// 								<div className='forms_field'>
// 									<i className='fa fa-solid fa-comment mx-2'></i>
// 									<textarea id='customerNote' name='Message' required rows={5} placeholder='Message'></textarea>
// 								</div>
// 							</fieldset>
// 							<div className='forms_buttons'>
// 								<input type='submit' value='Submit' className='forms_buttons-action' />
// 							</div>
// 						</form>
// 					</div>
// 				</div>
// 				<div className='row'>
// 					<iframe
// 					 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2063.328484620443!2d77.24045267337166!3d28.498921220969233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce10dd26b4c81%3A0xce258c6c7ac1ffae!2sGali%20No.%203%2C%20Sangam%20Vihar%2C%20New%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1720294584797!5m2!1sen!2sin" loading="lazy"
// 						style={{ minHeight: '400px', minWidth: '100%' }}
// 						allowFullScreen
// 					></iframe>
// 					</div>
// 			</div>
// 			<Footer />
// 		</div>
// 	);
// };

// export default ContactUs;

import React, { useState, useEffect } from 'react';
import Footer from '../../compos/Footer/Footer';
import Header from '../../compos/Header/Header';
import { BACKEND_URL } from '../../config';
import { Mail, Phone, Send, User, MessageSquare, CheckCircle, AlertCircle } from 'lucide-react';

const ContactUs = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const handleSubmit = async (event: { preventDefault: () => void; target: any }) => {
		event.preventDefault();
		setIsSubmitting(true);
		setSubmitStatus('idle');

		const form = event.target;
		const formData = new FormData(form);
		const data = Object.fromEntries(formData.entries());

		try {
			const response = await fetch(`${BACKEND_URL}/form/submit-form`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data),
			});

			if (response.ok) {
				setSubmitStatus('success');
				form.reset();
			} else {
				setSubmitStatus('error');
			}
		} catch (error) {
			console.error('Error submitting the form:', error);
			setSubmitStatus('error');
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className='min-h-screen bg-gray-50'>
			<Header />

			{/* Hero Section */}
			<div
				className='pt-8 pb-8 lg:pt-[52px] lg:pb-[52px] bg-gradient-to-r from-[#022c56] via-[#034068] to-[#045580] relative overflow-hidden'
				style={{ marginTop: 'var(--header-height)' }}
			>
				<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10'>
					<h1 className='text-4xl lg:text-5xl font-bold text-white mb-4'>Get in Touch</h1>
					<p className='text-lg text-blue-200 max-w-3xl mx-auto leading-relaxed'>
						Have questions, feedback, or need support? We'd love to hear from you. Our team is here to help you with all
						your reporting needs.
					</p>
					{/* Shown as plain text, not just behind the form: Google Play requires a
					    visible email address or phone number on the publisher's contact page. */}
					<a
						href='mailto:breporter.services@gmail.com'
						className='inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-full bg-white/10 text-white font-semibold no-underline hover:bg-white/20 hover:text-white'
					>
						<Mail className='w-5 h-5' />
						breporter.services@gmail.com
					</a>
				</div>
			</div>

			{/* Main Content */}
			<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16'>
				<div className='flex justify-center items-center'>
					{/* Contact Form */}
					<div className='bg-white rounded-2xl shadow-xl p-8 lg:p-12'>
						<div className='mb-8'>
							<h2 className='text-3xl font-bold text-gray-900 mb-4'>Send us a Message</h2>
							<p className='text-gray-600'>Fill out the form below and we'll get back to you as soon as possible.</p>
						</div>

						<form onSubmit={handleSubmit} className='space-y-4'>
							<div>
								<label htmlFor='name' className='block text-sm font-medium text-gray-700 mb-2 text-left'>
									Full Name
								</label>
								<div className='relative'>
									<User className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400' />
									<input
										type='text'
										id='name'
										name='Name'
										required
										className='w-full pl-12 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#022c56] focus:border-transparent transition-colors'
										placeholder='Enter your full name'
									/>
								</div>
							</div>

							<div>
								<label htmlFor='email' className='block text-sm font-medium text-gray-700 mb-2 text-left'>
									Email Address
								</label>
								<div className='relative'>
									<Mail className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400' />
									<input
										type='email'
										id='email'
										name='Email'
										required
										className='w-full pl-12 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#022c56] focus:border-transparent transition-colors'
										placeholder='Enter your email address'
									/>
								</div>
							</div>

							<div>
								<label htmlFor='phone' className='block text-sm font-medium text-gray-700 mb-2 text-left'>
									Phone Number
								</label>
								<div className='relative'>
									<Phone className='absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400' />
									<input
										type='tel'
										id='phone'
										name='Phone'
										required
										className='w-full pl-12 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#022c56] focus:border-transparent transition-colors'
										placeholder='Enter your phone number'
									/>
								</div>
							</div>

							<div>
								<label htmlFor='message' className='block text-sm font-medium text-gray-700 mb-2 text-left'>
									Message
								</label>
								<div className='relative'>
									<MessageSquare className='absolute left-3 top-3 w-5 h-5 text-gray-400' />
									<textarea
										id='message'
										name='Message'
										rows={5}
										required
										className='w-full pl-12 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors resize-none'
										placeholder='Tell us how we can help you...'
									></textarea>
								</div>
							</div>

							{/* Sleek status messages at bottom - matched to input thickness, text centered, icon left, responsive line breaks */}
							{(submitStatus === 'success' || submitStatus === 'error') && (
								<div
									className={`min-h-10 py-2 px-10 rounded-lg relative flex items-center justify-center animate-fade-in border shadow-sm ${
										submitStatus === 'success'
											? 'bg-emerald-50/50 border-emerald-100 text-emerald-800'
											: 'bg-rose-50/50 border-rose-100 text-rose-800'
									}`}
								>
									<div className='absolute left-3 flex items-center'>
										{submitStatus === 'success' ? (
											<CheckCircle className='w-4 h-4 flex-shrink-0' />
										) : (
											<AlertCircle className='w-4 h-4 flex-shrink-0' />
										)}
									</div>
									<span className='text-sm font-semibold leading-tight text-center'>
										{submitStatus === 'success' ? (
											<>
												Message sent! <br className='sm:hidden' />
												We'll get back to you shortly.
											</>
										) : (
											<>
												Submission failed. <br className='sm:hidden' />
												Please try again later.
											</>
										)}
									</span>
								</div>
							)}

							<button
								type='submit'
								disabled={isSubmitting}
								className='w-full bg-[#022c56] hover:bg-[#034068] disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center gap-2 shadow-lg hover:shadow-xl'
							>
								{isSubmitting ? (
									<>
										<div className='w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin'></div>
										Sending...
									</>
								) : (
									<>
										<Send className='w-5 h-5' />
										Send Message
									</>
								)}
							</button>
						</form>
					</div>
				</div>

				{/* Map Section */}
				<div className='mt-16'>
					<div className='bg-white rounded-2xl shadow-xl overflow-hidden'>
						<div className='p-8 border-b border-gray-200'>
							<h3 className='text-2xl font-bold text-gray-900 mb-2'>Find Us on the Map</h3>
							<p className='text-gray-600'>Visit our office or get directions to our location.</p>
						</div>
						<div className='relative'>
							<iframe
								src='https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d7011.531817397115!2d77.20092965626203!3d28.51668992073938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sKh.%20No.%20293%20S%2FF%2C%20Western%20Marg%2C%20Saidulajab%2C%20Near%20Kher%20Singh%20Estate%2C%20Saket%2C%20New%20Delhi%20-%20110030!5e0!3m2!1sen!2sin!4v1736932539874!5m2!1sen!2sin'
								loading='lazy'
								className='w-full h-96 lg:h-[500px]'
								allowFullScreen
								title='B-Reporter Office Location'
							></iframe>
						</div>
					</div>
				</div>
			</div>

			<Footer />
		</div>
	);
};

export default ContactUs;

// 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2063.328484620443!2d77.24045267337166!3d28.498921220969233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce10dd26b4c81%3A0xce258c6c7ac1ffae!2sGali%20No.%203%2C%20Sangam%20Vihar%2C%20New%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1720294584797!5m2!1sen!2sin' // PREVIOUS LOCATION
